export default __webpack_public_path__ + "static/media/cook6.1f40b19c.png";